import { useMemo } from 'react';
import { DateFormatting, Scope } from 'src/api/Enums';
import usePreferences from 'src/hooks/usePreference/usePreferences';

/**
 * Getting dateFormatList based on prefs
 */
const dateFormattingMap = new Map([
  [DateFormatting.DmyDot, ['DD.MM.YYYY', 'DD.M.YYYY', 'D.MM.YYYY', 'D.M.YYYY', 'DD.MM.YY', 'DD.M.YY', 'D.M.YY',
    'DD.MM', 'DD.M', 'D.M', 'DDMMYYYY', 'DDMMYY', 'DDMM', 'DD', 'D']],
  [DateFormatting.YmdDot, ['YYYY.MM.DD', 'YYYY.M.DD', 'YYYY.MM.D', 'YYYY.M.D', 'YY.MM.DD', 'YY.M.DD', 'YY.M.D',
    'MM.DD', 'M.DD', 'M.D', 'YYYYMMDD', 'YYMMDD', 'MMDD', 'DD', 'D']],
  [DateFormatting.DmySlash, ['DD/MM/YYYY', 'DD/M/YYYY', 'D/MM/YYYY', 'D/M/YYYY', 'DD/MM/YY', 'DD/M/YY', 'D/M/YY',
    'DD/MM', 'DD/M', 'D/M', 'DDMMYYYY', 'DDMMYY', 'DDMM', 'DD', 'D']],
  [DateFormatting.MdySlash, ['MM/DD/YYYY', 'M/DD/YYYY', 'MM/D/YYYY', 'M/D/YYYY', 'MM/DD/YY', 'M/DD/YY', 'M/D/YY',
    'MM/DD', 'M/DD', 'M/D', 'MMDDYYYY', 'MMDDYY', 'MMDD', 'DD', 'D']],
  [DateFormatting.SsDash, ['YYYY-MM-DD', 'YYYY-M-DD', 'YYYY-MM-D', 'YYYY-M-D', 'YY-MM-DD', 'YY-M-DD', 'YY-M-D',
    'MM-DD', 'M-DD', 'M-D', 'YYYYMMDD', 'YYMMDD', 'MMDD', 'DD', 'D']],
  [DateFormatting.MdyDash, ['MM-DD-YYYY', 'M-DD-YYYY', 'MM-D-YYYY', 'M-D-YYYY', 'MM-DD-YY', 'M-DD-YY', 'M-D-YY',
    'MM-DD', 'M-DD', 'M-D', 'MMDDYYYY', 'MMDDYY', 'MMDD', 'DD', 'D']]
]);

export const useDateFormatList = () => {
  const preferences = usePreferences(Scope.Company);

  return useMemo(() => {
    const dateFormatting = preferences?.['app.general.dateFormatting'];
    return dateFormattingMap.get(dateFormatting);
  }, [preferences]);
};

export default useDateFormatList;
